export const checkCianMfRegistry = () => {
  if (typeof window !== 'undefined' && '_cianMfRegistry' in window) {
    return true;
  }

  return false;
};
